import {css} from "@emotion/core";
import styled from "@emotion/styled";
import {colors, Flex} from "../ui";

export const total = css`
    font-size:18px;   
    font-weight:bold;   
`;


export const Check = styled.div`
    position:relative;
    width:25px;
    height:25px;
    border-radius:15px;
    transition: all 500ms cubic-bezier(0.175, 0.885, 0.320, 1.275);
    border:3px solid ${props => props.white ? "white" : "#e4e4e4"};
    margin: ${props=>props.abonar? "auto":"none"};
    cursor:pointer;
    
    input{
        position:absolute;
        top:0;
        left:0;
        width:110%;
        height:110%;
        opacity:0;
        z-index:22;
        cursor:pointer;
        
    }
    
    .check{
       width:26px;
       height:26px;
       transition: all 500ms cubic-bezier(0.175, 0.885, 0.320, 1.275); 
       transform: scale(${props => props.active ? 1 : 0});
       opacity:${props => props.active ? 1 : 0};
       position:absolute;
       top:-4px;
       left:-3px;
       
       img{
        width:100%;
        height:auto;
        display:block;
       }
    }
    
    &:hover{
        border-color:${colors.btn};
    }
`;

export const Datos = styled(Flex)`
       border-radius:12px;
       background-color:white;
       
       .main-check{
        border-right:1px solid ${colors.title};
       }
       
       .dato {
      
        border-bottom: 1px solid ${colors.title};
           
            &:last-child{
                border:none;
            }  
            
            @media all and (min-width: 768px) {
                 border-bottom:none;
                 border-left:1px solid ${colors.title};
                  
                  &:last-child{
                     border-left:1px solid ${colors.title};
                  }   
              }
             
            
            .description{
                width:100%;
                text-overflow:ellipsis;
                white-space: nowrap;
                overflow:hidden;
                font-size:13px;
                
            }   
       }
       
       .dato-inner{
          border-bottom: 1px solid ${colors.title};
       }
       
       
       
       @media all and (min-width:768px){
            .main-check{
             border-right:1px solid transparent;
           }
           
            .dato-inner{
                  border-bottom: none;
                  border-left:  1px solid ${colors.title};
                 p{font-size:13px;}
            }
            
            .lineUp{
                border-top: 1px solid ${colors.title}!important;
                padding-top:5px;
            }
       }
       
       @media all and (min-width:1200px){
        .lineUp{
                border-top: none!important;
            }
       }
`;
